(function () {
  const LIST_SELECTOR = '.cart-discount__applied-discounts .discounts[role="list"]';
  const LINE_ITEM_SELECTOR = '.discounts__discount--line-level';

  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      aggregateAll();
    });
  }

  function parseMoneyBRL(text) {
    if (!text) return 0;
    const cleaned = text.replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
    const val = Number(cleaned);
    return isNaN(val) ? 0 : Math.abs(val);
  }

  function formatMoneyBRL(num) {
    try { return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
    catch { return 'R$ ' + (num.toFixed(2)).replace('.', ','); }
  }

  function getCodeFromLi(li) {
    return (li.getAttribute('data-discount-code')
      || li.querySelector('[data-discount-code]')?.getAttribute('data-discount-code')
      || li.textContent || '').trim();
  }

  function aggregateList(list) {
    const items = Array.from(list.querySelectorAll(LINE_ITEM_SELECTOR));
    if (items.length <= 1) return; // nada a fazer

    const byCode = new Map();
    for (const li of items) {
      const code = getCodeFromLi(li);
      if (!code) continue;
      const amount = parseMoneyBRL(li.querySelector('.discount-amount')?.textContent || '');
      const acc = byCode.get(code) || { total: 0, nodes: [] };
      acc.total += amount;
      acc.nodes.push(li);
      byCode.set(code, acc);
    }

    // se todos já são únicos, sai
    if (![...byCode.values()].some(v => v.nodes.length > 1)) return;

    // Remove todos os line-level originais
    for (const li of items) li.remove();

    // Recria um <li> por código com a soma
    const frag = document.createDocumentFragment();
    for (const [code, data] of byCode.entries()) {
      const li = document.createElement('li');
      li.className = 'discounts__discount discounts__discount--line-level';
      li.setAttribute('data-discount-code', code);
      li.innerHTML = `
        <svg class="icon icon-discount" viewBox="0 0 12 12" aria-hidden="true">
          <path fill="currentColor" fill-rule="evenodd" d="M7 0h3a2 2 0 0 1 2 2v3a1 1 0 0 1-.3.7l-6 6a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 0-1.4l6-6A1 1 0 0 1 7 0m2 2a1 1 0 1 0 2 0 1 1 0 0 0-2 0" clip-rule="evenodd"></path>
        </svg>
        ${code}
        <span class="discount-amount">(-${formatMoneyBRL(data.total)})</span>
        <button type="button"
          class="cart-discount__remove-inline"
          data-discount-code="${code}"
          aria-label="Remover desconto ${code}"
          title="Remover cupom">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      `;
      frag.appendChild(li);
    }
    list.appendChild(frag);
  }

  function aggregateAll() {
    const lists = document.querySelectorAll(LIST_SELECTOR);
    if (!lists.length) return;
    lists.forEach(aggregateList);
  }

  // 1) Rodar no carregamento
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => aggregateAll(), { once: true });
  } else {
    aggregateAll();
  }

  // 2) Reagir apenas a eventos específicos, sem Observer global
  ['cart:updated', 'shopify:section:load', 'cart-drawer:open', 'cart-drawer:updated'].forEach(evt => {
    document.addEventListener(evt, () => schedule());
  });

})();
